/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AppointTrustCoordinatorRequest } from '../models';
import { AtcsSearchLawIdUsersRequest } from '../models';
import { BooleanResponse } from '../models';
import { DeleteSignatoryRequest } from '../models';
import { GetSignatoryByIdRequest } from '../models';
import { IndividualPracticeForSyncIEnumerableResponse } from '../models';
import { IndividualSummaryForTAIEnumerableResponse } from '../models';
import { LawIdUserLsApiViewIEnumerableResponse } from '../models';
import { ManageAuthorizedSignatoryPageStatusResponse } from '../models';
import { ManageSignatoryRequest } from '../models';
import { ManageSignatoryResponse } from '../models';
import { ManageSignatoryUserResponse } from '../models';
import { NumberOfPracticeWithoutTrustCoordinatorResponse } from '../models';
import { NumberOfUnapprovedFormResponse } from '../models';
import { SaveSignatoryRequest } from '../models';
import { SignatoryViewResponse } from '../models';
/**
 * PeopleAtcsApi - axios parameter creator
 * @export
 */
export const PeopleAtcsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAdmin | Save Trust Coordinator
         * @param {AppointTrustCoordinatorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminAppointTrustCoordinatorPost: async (body?: AppointTrustCoordinatorRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/Admin/AppointTrustCoordinator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Dashboard Number Of Practice Without Trust Coordinator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminDashboardGetNumberOfPracticeWithoutTrustCoordinatorGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/Admin/Dashboard/GetNumberOfPracticeWithoutTrustCoordinator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Dashboard Number Of Unapproved Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminDashboardGetNumberOfUnapprovedFormsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/Admin/Dashboard/GetNumberOfUnapprovedForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns Trust Contacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/People/Admin/GetTrustContacts/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns Trust Coordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/People/Admin/GetTrustCoordinators/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAdmin | Terminate Trust Contact
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut: async (individualPracticeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'individualPracticeId' is not null or undefined
            if (individualPracticeId === null || individualPracticeId === undefined) {
                throw new RequiredError('individualPracticeId','Required parameter individualPracticeId was null or undefined when calling apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut.');
            }
            const localVarPath = `/api/v2/Atcs/People/Admin/TerminateTrustContact/{individualPracticeId}`
                .replace(`{${"individualPracticeId"}}`, encodeURIComponent(String(individualPracticeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Delete Signatory
         * @param {DeleteSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleDeleteSignatoryPost: async (body?: DeleteSignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/DeleteSignatory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete: async (practiceCoreId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceCoreId' is not null or undefined
            if (practiceCoreId === null || practiceCoreId === undefined) {
                throw new RequiredError('practiceCoreId','Required parameter practiceCoreId was null or undefined when calling apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete.');
            }
            const localVarPath = `/api/v2/Atcs/People/ForceReleaseManageSignatoryLock/{practiceCoreId}`
                .replace(`{${"practiceCoreId"}}`, encodeURIComponent(String(practiceCoreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Current Manage Signatory User
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet: async (practiceCoreId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceCoreId' is not null or undefined
            if (practiceCoreId === null || practiceCoreId === undefined) {
                throw new RequiredError('practiceCoreId','Required parameter practiceCoreId was null or undefined when calling apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/People/GetCurrentManageSignatoryUser/{practiceCoreId}`
                .replace(`{${"practiceCoreId"}}`, encodeURIComponent(String(practiceCoreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet: async (practiceCoreId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceCoreId' is not null or undefined
            if (practiceCoreId === null || practiceCoreId === undefined) {
                throw new RequiredError('practiceCoreId','Required parameter practiceCoreId was null or undefined when calling apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/People/GetManageAuthorisedSignatoryPageStatus/{practiceCoreId}`
                .replace(`{${"practiceCoreId"}}`, encodeURIComponent(String(practiceCoreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Search LawId Users
         * @param {AtcsSearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetSearchLawIdUsersPost: async (body?: AtcsSearchLawIdUsersRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/GetSearchLawIdUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Signatories
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetSignatoriesPost: async (body?: ManageSignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/GetSignatories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Signatory
         * @param {GetSignatoryByIdRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetSignatoryPost: async (body?: GetSignatoryByIdRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/GetSignatory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Contacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/People/GetTrustContactsForTI/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Coordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Atcs/People/GetTrustCoordinatorsForTI/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleReleaseManageSignatoryLockPost: async (body?: ManageSignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/ReleaseManageSignatoryLock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact  | Returns true when manage signatory lock is successfully renewed
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleRenewManageSignatoryLockPost: async (body?: ManageSignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/RenewManageSignatoryLock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Save Signatory
         * @param {SaveSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleSaveSignatoryPost: async (body?: SaveSignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Atcs/People/SaveSignatory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeopleAtcsApi - functional programming interface
 * @export
 */
export const PeopleAtcsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAdmin | Save Trust Coordinator
         * @param {AppointTrustCoordinatorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleAdminAppointTrustCoordinatorPost(body?: AppointTrustCoordinatorRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleAdminAppointTrustCoordinatorPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Dashboard Number Of Practice Without Trust Coordinator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleAdminDashboardGetNumberOfPracticeWithoutTrustCoordinatorGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberOfPracticeWithoutTrustCoordinatorResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleAdminDashboardGetNumberOfPracticeWithoutTrustCoordinatorGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Dashboard Number Of Unapproved Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleAdminDashboardGetNumberOfUnapprovedFormsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberOfUnapprovedFormResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleAdminDashboardGetNumberOfUnapprovedFormsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns Trust Contacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualSummaryForTAIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns Trust Coordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualSummaryForTAIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAdmin | Terminate Trust Contact
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut(individualPracticeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut(individualPracticeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Delete Signatory
         * @param {DeleteSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleDeleteSignatoryPost(body?: DeleteSignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleDeleteSignatoryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(practiceCoreId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(practiceCoreId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Current Manage Signatory User
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet(practiceCoreId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManageSignatoryUserResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet(practiceCoreId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet(practiceCoreId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManageAuthorizedSignatoryPageStatusResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet(practiceCoreId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Search LawId Users
         * @param {AtcsSearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleGetSearchLawIdUsersPost(body?: AtcsSearchLawIdUsersRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserLsApiViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleGetSearchLawIdUsersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Signatories
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleGetSignatoriesPost(body?: ManageSignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManageSignatoryResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleGetSignatoriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Signatory
         * @param {GetSignatoryByIdRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleGetSignatoryPost(body?: GetSignatoryByIdRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryViewResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleGetSignatoryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Contacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualPracticeForSyncIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Coordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualPracticeForSyncIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleReleaseManageSignatoryLockPost(body?: ManageSignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleReleaseManageSignatoryLockPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact  | Returns true when manage signatory lock is successfully renewed
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleRenewManageSignatoryLockPost(body?: ManageSignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleRenewManageSignatoryLockPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Save Signatory
         * @param {SaveSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AtcsPeopleSaveSignatoryPost(body?: SaveSignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleAtcsApiAxiosParamCreator(configuration).apiV2AtcsPeopleSaveSignatoryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PeopleAtcsApi - factory interface
 * @export
 */
export const PeopleAtcsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TaAdmin | Save Trust Coordinator
         * @param {AppointTrustCoordinatorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminAppointTrustCoordinatorPost(body?: AppointTrustCoordinatorRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleAdminAppointTrustCoordinatorPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Dashboard Number Of Practice Without Trust Coordinator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminDashboardGetNumberOfPracticeWithoutTrustCoordinatorGet(options?: any): AxiosPromise<NumberOfPracticeWithoutTrustCoordinatorResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleAdminDashboardGetNumberOfPracticeWithoutTrustCoordinatorGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Dashboard Number Of Unapproved Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminDashboardGetNumberOfUnapprovedFormsGet(options?: any): AxiosPromise<NumberOfUnapprovedFormResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleAdminDashboardGetNumberOfUnapprovedFormsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns Trust Contacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualSummaryForTAIEnumerableResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns Trust Coordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualSummaryForTAIEnumerableResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAdmin | Terminate Trust Contact
         * @param {number} individualPracticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut(individualPracticeId: number, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut(individualPracticeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Delete Signatory
         * @param {DeleteSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleDeleteSignatoryPost(body?: DeleteSignatoryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleDeleteSignatoryPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(practiceCoreId: number, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(practiceCoreId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Current Manage Signatory User
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet(practiceCoreId: number, options?: any): AxiosPromise<ManageSignatoryUserResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet(practiceCoreId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
         * @param {number} practiceCoreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet(practiceCoreId: number, options?: any): AxiosPromise<ManageAuthorizedSignatoryPageStatusResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet(practiceCoreId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Search LawId Users
         * @param {AtcsSearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetSearchLawIdUsersPost(body?: AtcsSearchLawIdUsersRequest, options?: any): AxiosPromise<LawIdUserLsApiViewIEnumerableResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleGetSearchLawIdUsersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Signatories
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetSignatoriesPost(body?: ManageSignatoryRequest, options?: any): AxiosPromise<ManageSignatoryResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleGetSignatoriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns Signatory
         * @param {GetSignatoryByIdRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetSignatoryPost(body?: GetSignatoryByIdRequest, options?: any): AxiosPromise<SignatoryViewResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleGetSignatoryPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Contacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualPracticeForSyncIEnumerableResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Trust Coordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualPracticeForSyncIEnumerableResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleReleaseManageSignatoryLockPost(body?: ManageSignatoryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleReleaseManageSignatoryLockPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact  | Returns true when manage signatory lock is successfully renewed
         * @param {ManageSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleRenewManageSignatoryLockPost(body?: ManageSignatoryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleRenewManageSignatoryLockPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal,TrustCoordinator,TrustContact | Save Signatory
         * @param {SaveSignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AtcsPeopleSaveSignatoryPost(body?: SaveSignatoryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleAtcsApiFp(configuration).apiV2AtcsPeopleSaveSignatoryPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeopleAtcsApi - object-oriented interface
 * @export
 * @class PeopleAtcsApi
 * @extends {BaseAPI}
 */
export class PeopleAtcsApi extends BaseAPI {
    /**
     * 
     * @summary TaAdmin | Save Trust Coordinator
     * @param {AppointTrustCoordinatorRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleAdminAppointTrustCoordinatorPost(body?: AppointTrustCoordinatorRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleAdminAppointTrustCoordinatorPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Dashboard Number Of Practice Without Trust Coordinator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleAdminDashboardGetNumberOfPracticeWithoutTrustCoordinatorGet(options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleAdminDashboardGetNumberOfPracticeWithoutTrustCoordinatorGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Dashboard Number Of Unapproved Forms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleAdminDashboardGetNumberOfUnapprovedFormsGet(options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleAdminDashboardGetNumberOfUnapprovedFormsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns Trust Contacts
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet(practiceId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleAdminGetTrustContactsPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns Trust Coordinators
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleAdminGetTrustCoordinatorsPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAdmin | Terminate Trust Contact
     * @param {number} individualPracticeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut(individualPracticeId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleAdminTerminateTrustContactIndividualPracticeIdPut(individualPracticeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Delete Signatory
     * @param {DeleteSignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleDeleteSignatoryPost(body?: DeleteSignatoryRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleDeleteSignatoryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
     * @param {number} practiceCoreId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(practiceCoreId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(practiceCoreId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Returns Current Manage Signatory User
     * @param {number} practiceCoreId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet(practiceCoreId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleGetCurrentManageSignatoryUserPracticeCoreIdGet(practiceCoreId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Returns Part B Form Status
     * @param {number} practiceCoreId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet(practiceCoreId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet(practiceCoreId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Returns Search LawId Users
     * @param {AtcsSearchLawIdUsersRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleGetSearchLawIdUsersPost(body?: AtcsSearchLawIdUsersRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleGetSearchLawIdUsersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Returns Signatories
     * @param {ManageSignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleGetSignatoriesPost(body?: ManageSignatoryRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleGetSignatoriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Returns Signatory
     * @param {GetSignatoryByIdRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleGetSignatoryPost(body?: GetSignatoryByIdRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleGetSignatoryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns Trust Contacts
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet(practiceId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleGetTrustContactsForTIPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns Trust Coordinators
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet(practiceId: number, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleGetTrustCoordinatorsForTIPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Returns true when manage signatory lock is released
     * @param {ManageSignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleReleaseManageSignatoryLockPost(body?: ManageSignatoryRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleReleaseManageSignatoryLockPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact  | Returns true when manage signatory lock is successfully renewed
     * @param {ManageSignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleRenewManageSignatoryLockPost(body?: ManageSignatoryRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleRenewManageSignatoryLockPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal,TrustCoordinator,TrustContact | Save Signatory
     * @param {SaveSignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleAtcsApi
     */
    public apiV2AtcsPeopleSaveSignatoryPost(body?: SaveSignatoryRequest, options?: any) {
        return PeopleAtcsApiFp(this.configuration).apiV2AtcsPeopleSaveSignatoryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
